import AssessmentIcon from '@mui/icons-material/Assessment';
import { AggregateList } from './AggregateList';

export default {
	list: AggregateList,
	icon: AssessmentIcon,
};